



























































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog, Notify } from 'vant';
import { TrainingClassType } from '@/api/models';
import shiftEvaluation from '../shiftEvaluation.vue';
import courseEvaluation from '../components/courseEvaluation.vue';

enum TypeEnum {
  已评分 = 0,
  待评分 = 1,
  培训中评分 = 2,
}

@Component({
  components: {
    shiftEvaluation,
    courseEvaluation,
  },
})
export default class FeedBackList extends Vue {
  @Prop() feedbackStatus: string;
  classOfType = TypeEnum.待评分;
  courseOfType = TypeEnum.待评分;
  deptName: string = '';
  classFinished: boolean = false;
  teacherRadio: string = '待评价'; // 选择框
  shiftRadio: string = '待评价';
  feedbackData: any = [];
  loading: boolean = false;
  finished: boolean = false;
  teachersData: any = [];
  teachersListData: any = [];
  organizationListData: any = [];
  page: any = {
    pageIndex: 1,
    pageSize: 30,
  };
  imageStyle: any = {
    background: 'url(' + require('@/images/头像icon@2x.png') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  };

  aitEvaluate: any = []; // 待评教师
  commentedData: any = []; //已评教师

  currentClassData: any = []; // 当前点击的班次数据
  currentCourseData: any = []; // 当前的课程评价数据

  get levelString() {
    return val => models.EvaluationLevel[val];
  }

  @Watch('feedbackStatus', { deep: true, immediate: true })
  async initData(val) {
    if (val) {
      switch (val) {
        case '班次评价':
          this.getWaitEvaluateComData();
          break;
        case '教师评价':
          this.getWaitEvaluateTeaData();
          break;
      }
    }
  }

  /**培训班类型 */
  get TrainingClassType() {
    return TrainingClassType;
  }

  // 班次评价弹出层关闭事件
  classCancel() {
    this.page.pageIndex = 1;
    this.organizationListData = [];
    if (this.classOfType == TypeEnum.待评分) this.getWaitEvaluateComData();
    else this.organizationListData = [];
    this.getCommentedComData();
  }

  courseCancel() {
    this.page.pageIndex = 1;
    this.teachersListData = [];
    if (this.courseOfType == TypeEnum.待评分) this.getWaitEvaluateTeaData();
    else if (this.courseOfType == TypeEnum.已评分) this.getCommentedTeaData();
  }

  /**获取我的待评教师 */
  async getWaitEvaluateTeaData() {
    try {
      this.loading = true;
      const { data } = await api.TeacherEvaluation.getMyWaitEvaluate_GET({
        pageIndex: this.page.pageIndex++,
        pageSize: this.page.pageSize,
      });
      this.aitEvaluate = data.items;
      this.teachersListData = this.teachersListData.concat(this.aitEvaluate);
      if (this.teachersListData.length == data.totalItemCount || data.items?.length == 0) this.finished = true;
    } finally {
      this.loading = false;
    }
  }

  /**获取我的已评教师 */
  async getCommentedTeaData() {
    try {
      this.loading = true;
      const { data } = await api.TeacherEvaluation.getMyCommented_GET({
        pageIndex: this.page.pageIndex++,
        pageSize: this.page.pageSize,
      });
      this.commentedData = data.items;
      this.teachersListData = this.teachersListData.concat(this.commentedData);
      if (this.teachersListData.length == data.totalItemCount || data.items?.length == 0) this.finished = true;
    } finally {
      this.loading = false;
    }
  }

  ///#region 获取班次评价
  myWaitEvaluate: any = [];
  myCommente: any = [];

  //获取待评班次
  async getWaitEvaluateComData() {
    this.loading = true;
    try {
      const res = await api.ComperhensiveEvaluation.getMyWaitEvaluate_GET({
        pageIndex: this.page.pageIndex++,
        pageSize: this.page.pageSize,
      });
      if (res.success) {
        this.myWaitEvaluate = res.data.result.items;
        this.organizationListData = this.organizationListData.concat(this.myWaitEvaluate);
        if (this.organizationListData.length == res.data.result.totalItemCount || res.data.result.items.length == 0)
          this.classFinished = true;
        this.loading = false;
      } else {
        Notify({ type: 'danger', message: `查询失败${res.message}` });
        this.loading = false;
      }
    } finally {
      this.loading = false;
    }
  }

  /**获取已评班次 */
  async getCommentedComData() {
    this.loading = true;
    try {
      const res = await api.ComperhensiveEvaluation.getMyCommented_GET({
        pageIndex: this.page.pageIndex++,
        pageSize: this.page.pageSize,
      });
      if (res.success) {
        this.myCommente = res.data.result.items;
        this.organizationListData = this.organizationListData.concat(this.myCommente);
        if (this.organizationListData.length == res.data.result.totalItemCount || res.data.result.items.length == 0)
          this.classFinished = true;
        this.loading = false;
      } else {
        Notify({ type: 'danger', message: `查询失败${res.message}` });
        this.loading = false;
      }
    } finally {
      this.loading = false;
    }
  }

  teacherChange(e: any) {
    this.feedbackData = [];
    this.page.pageIndex = 1;
    this.teachersListData = [];
    this.finished = false;
    if (e == '已评价') {
      this.getCommentedTeaData();
    }
    if (e == '待评价') {
      this.getWaitEvaluateTeaData();
    }
  }

  shiftChange(e: any) {
    this.page.pageIndex = 1;
    this.organizationListData = [];
    this.classFinished = false;
    if (e == '已评价') {
      this.getCommentedComData();
    }
    if (e == '待评价') {
      this.getWaitEvaluateComData();
    }
  }

  async onLoad() {
    if (this.feedbackStatus == '教师评价') {
      if (this.teacherRadio == '待评价') {
        this.getWaitEvaluateTeaData();
      } else {
        this.getCommentedTeaData();
      }
    }

    if (this.feedbackStatus == '班次评价') {
      if (this.shiftRadio == '待评价') {
        this.getWaitEvaluateComData();
      } else {
        this.getCommentedComData();
      }
    }
  }

  //跳转到课程评价页面
  toTeacherFeedBack(item: any) {
    this.courseOfType = TypeEnum.待评分;
    this.currentCourseData = item;
    let trainingStartTime = new Date(item.trainingStartTime);
    let dateTimeNow = new Date();
    if (trainingStartTime < dateTimeNow) {
      (this.$refs.courseRef as any).show = true;
      // this.$router.push({
      //   name: 'feedback',
      //   params: { feedbackTitle: '评价教师', teacherDetail: item },
      // });
    } else {
      Dialog.alert({
        message: '当前课程还未开始，不能评价！',
      });
    }
  }

  //跳转到已评课程详情
  toTeacherDetail(item: any) {
    this.courseOfType = TypeEnum.已评分;
    this.currentCourseData = item;
    console.log('%c [ 已评课程 ]-401', 'font-size:13px; background:pink; color:#bf2c9f;', this.currentCourseData);
    (this.$refs.courseRef as any).show = true;
    // this.$router.push({
    //   name: 'reviewedDetail',
    //   params: { feedbackTitle: '已评教师', teacherDetail: item },
    // });
  }

  //跳转班次页面
  toOrganizationFeedBack(item: any) {
    this.classOfType = TypeEnum.待评分;
    this.currentClassData = item;
    let startClassDate = new Date(item.startClassDate);
    let dateTimeNow = new Date();
    if (startClassDate < dateTimeNow) {
      (this.$refs.shiftEvaluationRef as any).show = true;
      // this.$router.push({
      //   name: 'ShiftEvaluation',
      //   params: { feedbackTitle: '综合评价', comprehensiveDetail: JSON.stringify(item) },
      // });
    } else {
      Dialog.alert({
        message: '当前培训班培训还未开始，不能评价！',
      });
    }
  }

  //已评班次弹窗
  toComprehensiveDetail(item: any) {
    this.classOfType = TypeEnum.已评分;
    this.currentClassData = item;
    (this.$refs.shiftEvaluationRef as any).show = true;
    // this.$router.push({
    //   name: 'reviewedDetail',
    //   params: { feedbackTitle: '综合评价', comprehensiveDetail: item },
    // });
  }

  mounted() {
    this.getWaitEvaluateComData();
  }
}
